<template>
    <div>
        <div class="search-condition-text">
            <label v-if="typeof labelText !== 'undefined'">{{labelText}}</label>
            <label class="switch" :value="value" tabindex="0">
                <input type="checkbox" :checked="value" v-on:change="onChangeEvent($event)" tabindex="-1">
                <span class="slider round"></span>
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BBtnSwitch",
        props:{
            labelText: String,
            value: Boolean,
        },
        data(){
            return {
            }
        },
        methods :{
            onChangeEvent(event){
                this.$emit("changed",event.target.checked);
                this.$emit("input",event.target.checked);
            }
        }
    }
</script>

<style scoped>
    .search-condition-text {
        display: flex;
        position: relative;
        justify-content: flex-start;
        align-items: center;
        padding: 10px;
        font-size: 14px;
    }

    .checkbox {
        display: none;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 55px;
        height: 30px;
        outline: none;
    }

    .switch:hover span,
    .switch:focus span{
        box-shadow: 0 0 5px #2196f3;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 30px;
        width: 30px;
        left: 0px;
        box-shadow: 0px 1px 5px 0px rgba(2, 44, 63, 0.44);
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    input:checked+.slider {
        background: #0171A3;
    }

    input:focus+.slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

</style>